export default {
  innovator: {
    title: "the Innovator",
    quotes: [
      "We can’t solve problems using the same kind of thinking we used when we created them. - Albert Einstein (Physicist)",
      "What is now proved was once only imagined. - William Blake (Poet, Painter)",
      "Creativity is intelligence having fun - Albert Einstein (Physicist)",
      "Do not fear mistakes. There are none. - Miles Davis (Musician)",
    ],
    icons: [
      "Albert Einstein (Physicist)",
      "Miles Davies (Musician)",
      "Grace Hopper (Computing Pioneer & Navy Admiral)",
      "David Bowie (Musician)",
      "Marie Curie (Physicist & Chemist)",
      "Ada Lovelace (The first Computer Programmer in history)",
      "Zahar Hadid (Architect)",
      "David Walliams (Comedian & Writer)",
    ],
    character_qualities: [
      "Innovators are the restless creators, constantly searching for the next game-changing idea or invention.",
      "They are the visionaries, willing to think the unthinkable, to see the world differently, and then to follow through and challenge established ideas and practices. Many of their ideas won’t work; failure and appearing foolish are part and parcel of their world.",
      "They have boundless curiosity, striving to anticipate how the world may change. They love to ask ‘why?’, ‘what if?’ and ‘why not?’.",
      "They will move quickly from one idea to the next as associations and half-ideas flow to and fro. ",
      "They leave a stamp of creativity wherever they go, whether it’s about finding a new way of organising a to-do list, or radically rethinking how to do space travel.",
    ],

    valued_for: [
      "Restless creativity",
      "Boldness",
      "Willing to risk failure",
      "Follow convictions",
      "Brings fresh thinking",
      "Openness to what’s new",
    ],
    may_lose_impact_by: [
      "Lacking self-belief",
      "Neglecting routine tasks",
      "Seeming disconnected from reality",
    ],
    jyre_strengths: ["Curiosity", "Originality", "Quick mind", "Simplifies"],
  },

  entrepreneurial: {
    title: "the Entrepreneurial Leader",
    quotes: [
      "When you undervalue what you do, the world will undervalue who you are. - Oprah Winfrey (Media figure)",
      "You need to see failure as the beginning and the middle but never entertain it as an end. - Jessica Herrin (Business founder)",
      "The biggest risk is not taking any risk... In a world that is changing really quickly, the only strategy that is guaranteed to fail is not taking risks. - Mark Zuckerberg (Business founder)",
      "Don’t try to do everything by yourself, but try to connect with people and resources. - Chieu Cao (Founder & CEO of Mintago)",
      "Passion, creativity, and resilience are the most crucial skills in business. If you’ve got those you’re ready to embark on the journey. - Jo Malone (Founder of Jo Malone)",
    ],
    icons: [
      "Oprah Winfrey (Media figure)",
      "Vera Wang (Designer)",
      "Gary Vaynerchuk (Entrepreneur & Author)",
      "Richard Branson (Business founder)",
      "Victoria Beckham (Fashion designer & Singer)",
    ],
    character_qualities: [
      "Entrepreneurial characters are great at spotting the potential in situations and willing to embrace risks in order to capture opportunities.",
      "Their focus is outwards: to markets, customers, ideas and technologies.",
      "They are open to change and this openness means that they are willing to embrace new trends that others might dismiss.",
      "They will often be the people providing fresh perspective to their team or organisation.",
      "They connect easily, and will often have a large network of contacts, which together with their personal resourcefulness and determination to follow through, means Entrepreneurial characters are the people who turn possibilities into reality.",
    ],
    valued_for: [
      "Spots value others miss",
      "Comfortable with ambiguity",
      "Adaptable and open-minded",
      "Action-oriented",
      "Bring energy and optimism",
      "Deal-maker",
    ],
    may_lose_impact_by: [
      "Being self-centred",
      "Taking others ideas as their own",
      "Won’t be managed",
    ],
    jyre_strengths: ["Risk-taking", "Sees Opportunities", "Bravery"],
  },

  executional: {
    title: "the Executional Leader",
    quotes: [
      "Done is better than perfect. - Sheryl Sandberg (Business leader & Writer)",
      "Work smart. Get things done. No nonsense. Move fast. - Susan Wojcicki (Business leader)",
      "Vision without execution is hallucination. - Thomas Eddison (Inventor & Business founder)",
      "Knowing is not enough. You must take action. - Tony Robbins (Author & Motivational speaker)",
      "I never dreamed about success. I worked for it. - Estee Lauder (Business founder)",
      "Amateurs sit and wait for inspiration, the rest of us just get up and go to work. - Stephen King (Writer)",
    ],
    icons: [
      "Estee Lauder  (Founder of EL Cosmetics)",
      "Susan Wojcicki (Business leader)",
      "Rupert Murdoch (Media mogul)",
      "Sheryl Sandberg (Business leader & Writer)",
      "Isambard Kingdom Brunel (Engineer)",
      "J.R.D. Tata (Entrepreneur)",
    ],
    character_qualities: [
      "The Executional character is driven to achieve great results, working tirelessly on challenging tasks until completion.",
      "They galvanise and encourage the efforts of others, unaffected by nuances of emotions and  politics.",
      "They move quickly from  ideas to action, often initiating action while the discussion is still happening.",
      "They are task oriented and no-nonsense - tools are there to be used rather than polished. With their strong focus on getting the job done, the Executional character is driven to ensure they and their team deliver, moving onto the next task almost before the current one is finished and rarely taking time to draw breath, creating pace and momentum for teams and organisations.",
    ],
    valued_for: [
      "Hyper-focus on delivery",
      "Motivated by difficult challenges",
      "Unstoppable once started",
      "Get things done immediately",
      "Tough-minded",
      "Drive through obstacles",
    ],
    may_lose_impact_by: [
      "Pushing self and others too hard",
      "Lacking empathy and curiosity about people",
      "Firing before they have taken aim",
    ],
    jyre_strengths: ["Appetite", "Grip", "Self-belief", "Perseverance"],
  },

  practical: {
    title: "the Practical Leader",
    quotes: [
      "I wouldn’t ask anybody to do something I wouldn’t do myself. - Indra Nooyi (Former CEO, PepsiCo)",
      "It is far better to buy a wonderful company at a fair price, than a fair company at a wonderful price. - Warren Buffet (Investor)",
      "I can’t change the direction of the wind, but I can adjust my sails to reach my destination. - Jimmy Dean (Actor & Businessman)",
      "Conflict is inevitable, but combat is optional. - Max Lucado (Author & Politician)",
    ],
    icons: [
      "Indra Nooyi (Former CEO PepsiCo)",
      "Howard Schultz (Former CEO of Starbucks)",
      "Keanu Reeves (Actor)",
      "George Washington (Former US President)",
      "Anne Wojcicki (Co-founder & CEO of genomics company 23andMe)",
    ],
    character_qualities: [
      "Practical characters focus on translating strategy into tangible results. They have a strong sense of ownership and quietly effective approach that means colleagues quickly come to know they can rely on them. They are the ones who will stick with something until it’s fully implemented and working smoothly.",
      "They have a deep understanding of what will work in the real world, bringing realism and pragmatism to a team. At their best, they balance short-term delivery with a long-term perspective, doing things now that will still make sense in the future.",
      "Practical characters are often process people, with a sustained focus on improving the quality, reliability and effectiveness of whatever they are leading.",
    ],
    valued_for: [
      "Focus on what is realistic and achievable",
      "Staying with something to completion",
      "Consistent",
      "Fair-minded",
      "Stabilise a team",
      "Creating a track-record of delivery",
    ],
    may_lose_impact_by: [
      "Being resistant to change",
      "Being uncomfortable with ambiguity",
      "Missing opportunities through focus on practicalities",
    ],
    jyre_strengths: ["Achievable", "Optimises", "Ownership", "Creates solutions"],
  },

  strategist: {
    title: "the Strategist",
    quotes: [
      "It wasn’t raining when Noah built the ark. - Howard Ruff (Financial Advisor and Writer)",
      "The essence of strategy is choosing what not to do. - Michael Porter (Academic, Researcher)",
      "It is the mark of an educated mind to be able to entertain a thought without accepting it. - Aristotle (Philosopher)",
      "Every battle is won before it is fought. - Sun Tzu (Military Strategist and writer)",
      "The power to control our species’ genetic future is awesome and terrifying. Deciding how to handle it may be the biggest challenge we have ever faced. - Jennifer Doudna (Biochemist)",
    ],
    icons: [
      "Sun Tzu (Military Strategist and writer)",
      "Jennifer Doudna (Biochemist)",
      "Anand Mahindra (Business Leader)",
      "Garry Kasparov (Chess champion, Political activist)",
      "Wu Zetian (Chinese Empress of the Wu Zhou Dynasty)",
    ],
    character_qualities: [
      "Strategists provide clarity about overall direction, working from deep analysis to bring insight and guidance. They are the people who inform and shape organisational strategy, anticipating challenges that others miss or neglect. They use these insights to understand how factors might play out in the future, and track the possible impacts on technologies, markets, organisations and people.",
      "Often the voice of reason, the Strategist helps others keep sight of the longer-term picture.",
      "They balance independent thought and informed decision-making.",
      "They value breadth as well as depth of thinking and can bring insight about what needs to happen to move a difficult task forward, but also to unstick a relationship, or handle a tricky people situation.",
    ],
    valued_for: [
      "Independence of thinking",
      "Far-sighted, linking past to future",
      "Voice of reason and insight",
      "Guide others",
      "Wisdom on what needs to happen next",
      "Thoroughness of analysis",
    ],
    may_lose_impact_by: [
      "Appearing too sceptical",
      "Becoming lost in analysis",
      "Moving too slowly in fast-paced environments",
    ],
    jyre_strengths: ["Judgement", "Open-minded", "Insightful", "Thinks Ahead"],
  },
  servant: {
    title: "the Servant Leader",
    quotes: [
      "A good head and a good heart are always a formidable combination. - Nelson Mandela (Statesman)",
      "The key to greatness is to look for people’s potential and spend time developing it. - Peter Drucker (Author, Educator)",
      "People do not care how much you know until they know how much you care. - John C. Maxwell (Author, Speaker)",
      "Treat employees like they will make a difference and they will. - Jim Goodnight (Business leader)",
      "True autonomy relies on us feeling securely connected to other human beings. - Mary Ainsworth (Developmental Psychologist)",
      "It is amazing what you can accomplish if you do not care who gets the credit. - Harry Truman (33rd President of the USA)",
    ],
    icons: [
      "Nelson Mandela  (Statesman)",
      "Queen Elizabeth II (Royal)",
      "Winston Churchill (Former British Prime Minister)",
      "Doreen Lawrence (Campaigner, Activist)",
      "Mary Ainsworth (Developmental Psychologist)",
      "Satya Nadella (CEO, Microsoft)",
    ],
    character_qualities: [
      "The Servant character focuses on the growth and wellbeing of others, guided by their core values and beliefs.",
      "They get their own ego out of the way, focusing their attention on their team and organisation.",
      "They will bring awareness and sensitivity to emotions and relationships.",
      "They care about being inclusive.",
      "They pull people together around shared goals, recognising, valuing and playing to people’s strengths, helping the team to reach its true potential. Many Servant characters come to personify the team, embodying its core values and identity.",
      "They handle conflict with calmness, drawing people together to find resolutions, effortlessly seeing both sides of the argument.",
    ],
    valued_for: [
      "Responsibility for the team",
      "Supportive and considerate",
      "Acknowledging and playing to others’ strengths",
      "Moral compass",
      "Quiet concern for values",
      "Loyalty",
    ],
    may_lose_impact_by: [
      "Feeling contribution goes unrecognised",
      "Saying ‘yes’ despite feeling overwhelmed",
      "Being inflexible when morals or values are challenged",
    ],
    jyre_strengths: ["Other awareness", "Fairness", "Humility", "Self awareness"],
  },

  transformational: {
    title: "the Transformational Leader",
    quotes: [
      "One child, one teacher, one book, one pen can change the world. - Malala Yousafzai (Political Activist)",
      "Our lives begin to end the day we become silent about things that matter. - Martin Luther King (Political Leader)",
      "Don’t be trapped into living with the results of other people’s thinking. - Steve Jobs (Apple founder)",
      "We may encounter many defeats but we must not be defeated. - Maya Angelou (Poet, Activist)",
    ],
    icons: [
      "Malala Yousafzai (Political Activist)",
      "Martin Luther King Jr (Political Leader)",
      "Elon Musk (Engineer, Business founder)",
      "Maya Angelou (Poet, Activist)",
      "Jóhanna Sigurðardóttir (First Female Prime Minister of Iceland)",
      "Jack Ma (Business Magnate)",
      "Steve Jobs (CEO & Co-founder, Apple)",
    ],
    character_qualities: [
      "The Transformational character is driven to bring positive change to the worlds in which people live and work.",
      "Their focus is on helping teams, organisations and the wider society find new and productive adaptations to a changing world.",
      "They understand that people often instinctively resist change, and they work resourcefully and resiliently to orchestrate changes in beliefs, mindsets, power-structures and culture.",
      "They tune into the emotions and relationships around them and are sensitive to the nature of power and influence.",
      "They listen as much to what’s not said as to what is said, creating fresh perspective and insight for others, coupled with the energising drive to bring about transformational change.",
    ],
    valued_for: [
      "Energise people about improving their world",
      "Understand who to influence and how",
      "Get people on board",
      "Drive for what others see as unthinkable",
      "Resilient in the face of resistance",
      "Empowering and inspiring of others",
    ],
    may_lose_impact_by: [
      "Not exercising judgement about what to challenge or disrupt",
      "Having unrealistic ambitions and impatience about pace of change",
      "Unwilling to accept established authority and procedures",
    ],
    jyre_strengths: ["Perspective", "Influential", "Resilience", "Handles conflict"],
  },
  charismatic: {
    title: "the Charismatic Leader",
    quotes: [
      "Don't ever underestimate the importance you can have, because history has shown us that courage can be contagious and hope can take on a life of its own. - Michelle Obama (Lawyer & Former First Lady)",
      "A boss has the title, a Leader has the people. - Simon Sinek (Author & Speaker)",
      "People may not remember what you did or what you said but they will always remember how you made them feel - Maya Angelou (Author & Activist)",
    ],
    icons: [
      "Michelle Obama (Lawyer & Former First Lady)",
      "Princess Diana (Royal)",
      "Dalai Lama (Spiritual leader)",
      "John Lennon (Musician)",
      "Freddie Mercury (Singer & Songwriter)",
      "Phoebe Waller-Bridge (Actress)",
      "Kamala Harris (First Female Vice President)",
    ],
    character_qualities: [
      "Charismatic characters paint a compelling vision of the future, generating excitement, energy, and movement. Their excitement about the potential they see around themselves, whether in a person, product or political movement, creates an emotional draw for others. It pulls people towards them, drawing them in through their inner conviction and sense of possibilities and potential.",
      "Whether quiet or loud, they build relationships readily, are often charming and connect easily on an emotional level, helping  awaken and motivate. The Charismatic character is  an engaging story teller, turning something that otherwise might be thorough and analytical but dry, into a story that can ignite passion and spark action.",
    ],
    valued_for: [
      "Inspirational",
      "Excitement about how things could be",
      "Story-tellers",
      "Energise others",
      "Creating aspiration",
      "Captivating and engaging their audience",
    ],
    may_lose_impact_by: [
      "Not allowing facts to get in the way of a good story",
      "Being easily distractible",
      "Relying too much on charm to get own way",
    ],
    jyre_strengths: ["Zest", "Optimism", "Connects"],
  },
  professional: {
    title: "the Professional",
    quotes: [
      "Do what you do so well that they will want to see it again and bring their friends. - Walt Disney (Creator of Disney)",
      "Always be more than you appear and never appear to be more than you are. - Angela Merkel (Politician)",
      "I want to look back on my career and be proud of the work, and be proud that I tried everything. - Jon Stewart (Actor, Host)",
      "It's determination and commitment to an unrelenting pursuit of your goal- a commitment to excellence- that will enable you to attain the success you seek. - Mario Andretti (Former racing driver)",
    ],
    icons: [
      "Walt Disney (Creator of Disney)",
      "Angela Merkel (Politician)",
      "Shami Chakrabarti (Human Rights Activist, Politician)",
      "Daniel Day-Lewis (Actor)",
      "Emma Watson (Actress, Activist)",
      "Anna Wintour (Editor, Journalist)",
      "Ranulph Fiennes (British Explorer)",
    ],
    character_qualities: [
      "The Professional is known for their commitment to mastery of their craft, whether this craft is a recognised profession, a way of working or a knowledge or skill-set.",
      "They have high standards and equally high expectations of themselves.",
      "They are seen as dependable, disciplined and determined to follow through on what they say.",
      "They are dedicated individuals who work diligently in the service of others - especially if they consider someone as a client.",
      "They do their preparation, are knowledgeable about their field, and are emotionally even-keeled.",
      "Their strength is to work with sustained focus and determination to deliver on their commitments: they have the kind of self-regulation that means little will distract them nor push them off balance.",
    ],
    valued_for: [
      "Always prepared",
      "Strive to be the best at what they do",
      "Self-disciplined",
      "Commitment to deliver on expectations",
      "Depth of knowledge and expertise",
      "Thoroughness and work-rate",
    ],
    may_lose_impact_by: [
      "Being impersonal and always objective",
      "Unwilling to take risks",
      "Inflexible belief that there is a right-way to proceed",
    ],
    jyre_strengths: ["Prudence", "Self-regulation", "Consistency", "Manages Expectations"],
  },
};
